import { gql } from 'graphql-request';
import { getOrgId, graphQLClient } from '@devd-client/api';

export const sprintMetricGql = async (
  startDate: string,
  endDate: string,
  teamId: string,
  projectsFilter: string[],
  sprintId: string,
  sprintIds: string[],
  pageSize: number,
  pageNumber: number,
  bySp: boolean,
  status: string,
  type: string
): Promise<any> =>
  await graphQLClient.request(
    gql`
      query GetSprintMetricsWithStatus(
        $teamId: String!
        $sprintId: String
        $sprintIds: [String]
        $startDate: String!
        $endDate: String!
        $orgId: String!
        $pageSize: Int
        $pageNumber: Int
        $bySp: Boolean
        $status: String!
        $type: String
        $projectsFilter: [String]
        $timeZone: String
      ) {
        SprintMetricsWithStatus(
          filter: {
            orgId: $orgId
            teamId: $teamId
            startDate: $startDate
            endDate: $endDate
            sprintId: $sprintId
            sprintIds: $sprintIds
            status: $status
            type: $type
            projectsFilter: $projectsFilter
            timeZone: $timeZone
          }
          bySp: $bySp
          pageSize: $pageSize
          pageNumber: $pageNumber
        ) {
          reports {
            sprintDetail {
              orgId
              sprintId
              sprintName
              sprintDuration
              startDate
              endDate
              status
              overCommitmentRate
              scopeCreepRate
              blockedIssues
            }
            sprintPlanning {
              tasks {
                name
                value
              }
              planningAccuracy
            }
            sprintProgress {
              tasks {
                status
                value
                color
              }
            }
            sprintTaskDist {
              tasksDistribution {
                status
                value
                color
              }
            }
            sprintVelocity {
              chart
            }
          }
          currentPage
          totalPages
          chartDataState
          zs
          chartError {
            message
            link
          }
        }
      }
    `,
    {
      orgId: getOrgId(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      teamId,
      sprintId,
      sprintIds,
      startDate,
      endDate,
      pageSize,
      pageNumber,
      bySp,
      status,
      type,
      projectsFilter,
    }
  );
